import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { IconStarter, IconBusiness, IconProfessional } from './PlanIcons'
import AuditModal from './AuditModal'

const IconTrue = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0002 15.172L19.1922 5.979L20.6072 7.393L10.0002 18L3.63623 11.636L5.05023 10.222L10.0002 15.172Z" fill="#57007B"/></svg>`

const plansData = {
    "INR": [
        { name: 'STARTER', icon: IconStarter, price: '₹30,000', extraLabel: 'One-time cost', extraCost: '' },
        { name: 'BUSINESS', icon: IconBusiness, price: '₹60,000', extraLabel: 'One-time cost', extraCost: '', popular: true },
        { name: 'PROFESSIONAL', icon: IconProfessional, price: '₹90,000', extraLabel: 'One-time cost', extraCost: '' },
    ],
    "USD": [
        { name: 'STARTER', icon: IconStarter, price: '$500', extraLabel: 'One-time cost', extraCost: '' },
        { name: 'BUSINESS', icon: IconBusiness, price: '$1000', extraLabel: 'One-time cost', extraCost: '', popular: true },
        { name: 'PROFESSIONAL', icon: IconProfessional, price: '$1500', extraLabel: 'One-time cost', extraCost: '' },
    ]
}

const tableData = [
    { titleText: 'Free Theme', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Paid Theme', col1: 'Add-on', col2: 'Add-on', col3: 'Add-on' },
    { titleText: 'Any Extension/ Plugin/ Application', col1: 'Add-on', col2: 'Add-on', col3: 'Add-on' },
    { titleText: 'HomePage Banners', col1: '2', col2: '4', col3: '6' },
    { titleText: 'HomePage Banner Video', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Revisions - Graphic + HTML', col1: '1', col2: '2', col3: '3' },
    { titleText: 'Collection', col1: '6', col2: '12', col3: '18' },
    { titleText: 'Product Editing &amp; Listing', col1: '15', col2: '30', col3: '45' },
    { titleText: 'Team Level', col1: 'Skilled', col2: 'Professional', col3: 'Expert' },
    { titleText: 'Testing In Browser', col1: 'Chrome', col2: 'Firefox <br>Chrome', col3: 'Edge <br>Firefox <br>Chrome' },
    { titleText: 'Custom Product Page', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Mega Menu Setup', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Facebook Pixel', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Chat', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'WordPress Blog With 3 Blog Content <br> (Server Cost 8100₹per year)', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Old Web URL Optimization', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Google Language Translator', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Custom Store Email Template Design', col1: '-', col2: '1', col3: '2' },
    { titleText: 'SEO Basic for Web Pages <br>Basic keyword research &amp; selection <br> Title tags optimization <br>Meta tag optimization <br>XML site map <br>Sitemap.xml <br>Robots.txt <br> Website indexing using Google search console', col1: '-', col2: '10', col3: '20' },
    { titleText: 'Local SEO / Business Listing', col1: '-', col2: IconTrue, col3: IconTrue },
    { titleText: 'Custom Section - Home Page', col1: '2', col2: '4', col3: '6' },
    { titleText: 'Market/Country', col1: '1', col2: '1', col3: '2' },
    { titleText: '404 Error Optimization', col1: '-', col2: IconTrue, col3: IconTrue },
    { titleText: 'WWW - One URL For SEO', col1: '-', col2: IconTrue, col3: IconTrue },
    { titleText: 'Non Broken Link', col1: '-', col2: IconTrue, col3: IconTrue },
    { titleText: 'HomePage Mobile Banner If Theme Supported', col1: '-', col2: IconTrue, col3: IconTrue },
    { titleText: 'Footer Menu', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Privacy Policy', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Refund Policy', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Shipping Policy', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Term and Condition', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Contact Details', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Order Cart/Checkout Page', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Domain Setup', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Theme Suggestion', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'CTA', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Check Out setting', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Taxes Setting', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Gift Card Setting', col1: '-', col2: '-', col3: IconTrue },
    { titleText: 'Set Themes Color Combination According To Logo', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Finding Free Images Related To Contents', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Site Search', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Free SSL Certificate &amp; Installation', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Unlimited Product/Item To Be Uploaded By Client', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Google Analytics Setup', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Social Media Networking Linking', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Sticky Menu', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'WhatsApp Share', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Favicon. Icon', col1: IconTrue, col2: IconTrue, col3: IconTrue },
    { titleText: 'Testing / Quality Check', col1: IconTrue, col2: IconTrue, col3: IconTrue }
];

export default function WoocomPlanTable() {
    const [currency, setCurrency] = useState('INR');
    const [showAuditModal, setShowAuditModal] = useState(false);

    const plans = plansData[currency];

    return (
        <div className="pricing-new cSection">
            <div className="cContainer">
                <div className="pricing-currency-select">
                    <div className="currency-toggle">
                        <button className={currency === 'INR' ? 'active' : ''} onClick={() => setCurrency('INR')}>₹INR</button>
                        <button className={currency === 'USD' ? 'active' : ''} onClick={() => setCurrency('USD')}>$USD</button>
                    </div>
                </div>

                <div className="pricing-unified-wrapper">
                    <table className="pricing-unified-table">
                        <thead>
                            <tr>
                                <th className="features-header">
                                    <h3>Our Plans</h3>
                                    <p>Select the best plan for your needs.</p>
                                </th>
                                {plans.map((plan, idx) => (
                                    <th className={`plan-header ${plan.popular ? 'popular' : ''}`} key={idx}>
                                        <div className="plan-header-content">
                                            {plan.popular && <span className="popular-badge">Popular</span>}
                                            {plan.icon && <div className="plan-icon" dangerouslySetInnerHTML={{ __html: plan.icon }}></div>}
                                            <span className="plan-name">{plan.name}</span>
                                            <div className="plan-price" dangerouslySetInnerHTML={{ __html: plan.price }}></div>
                                            {plan.originalPrice && <div className="plan-price-original">{plan.originalPrice}</div>}
                                            {!plan.originalPrice && <div className="plan-price-original"></div>}
                                            <span className="plan-type">One-time cost</span>
                                            {plan.extraCost && <span className="plan-extra">{plan.extraLabel}: {plan.extraCost}</span>}
                                            <button className="plan-cta" onClick={() => setShowAuditModal(true)}>Get Started</button>
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row, idx) => (
                                <tr key={idx}>
                                    <td dangerouslySetInnerHTML={{ __html: row.titleText }}></td>
                                    <td className={plans[0]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col1 }}></span></td>
                                    <td className={plans[1]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col2 }}></span></td>
                                    <td className={plans[2]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col3 }}></span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <AuditModal show={showAuditModal} handleClose={() => setShowAuditModal(false)} />

                <div className="pricing-notes">
                    <h4 className="notes-title">Note:-</h4>
                    <ul className="notes-list">
                        <li>The client should provide clear photographs, videos, and content.</li>
                        <li>Once the material is uploaded to the website, any changes will be chargeable afterward.</li>
                        <li>18% GST Tax extra (for Indian customers only).</li>
                        <li>Payment Gateway + Forex cost extra (for international customers only).</li>
                        <li>Domain &amp; Hosting cost is extra (not included in the above pricing).</li>
                        <li>WooCommerce &amp; WordPress plugin license costs are extra if premium plugins are selected.</li>
                        <li>Advance charges apply to app and plugin recommendations (Charges are non-refundable).</li>
                        <li>If there are any complications with any WooCommerce extension or plugin, additional charges will apply.</li>
                        <li>Product images and descriptions must be provided by the client in the required format.</li>
                        <li>Payment gateway integration (e.g., Razorpay, PayPal) charges are not included.</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
